module.exports = __webpack_public_path__ + "img/logo.1808f866.svg";